export default "__VITE_ASSET__C$SoWCzz__"